import { render } from "./App.vue?vue&type=template&id=49df916e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=49df916e&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__